import prop from 'ramda/es/prop';
import React from 'react';

import { Sidebar } from '../Sidebar';
import SidebarLinkItem from '../SidebarLinkItem';
import SidebarRootItem from '../SidebarRootItem';
import SidebarSectionItem from '../SidebarSectionItem';

export type TableOfContents = {
  url?: string;
  title?: string;
  items?: TableOfContents[];
};

type PropTypes = {
  tableOfContents: TableOfContents;
  itemHighlight?: boolean;
};

const propTitle = prop('title');

const TableOfContentsSidebar = ({ tableOfContents, itemHighlight = true }: PropTypes): JSX.Element => (
  <Sidebar>
    {tableOfContents?.items?.filter(propTitle).map((table) => (
      <SidebarRootItem key={table.url} to={table.url} titleSidebar={table.title}>
        {table.items?.filter(propTitle).map((item) => (
          <SidebarSectionItem key={item.url} to={item.url} title={item.title} highlight={itemHighlight}>
            {item.items?.filter(propTitle).map((link) => (
              <SidebarLinkItem key={link.url} to={link.url} highlight={itemHighlight}>
                {link.title}
              </SidebarLinkItem>
            ))}
          </SidebarSectionItem>
        ))}
      </SidebarRootItem>
    ))}
  </Sidebar>
);

export default TableOfContentsSidebar;
